import { SET_RESTAURANT_PROMOCODES } from "../restaurant/constants";

const initState = [];

export default function restaurantPromocodeReducer(state = initState, action) {
  switch (action.type) {
    case SET_RESTAURANT_PROMOCODES:

      return action.payload;

    default:
      return state;
  }
}
